import React, { lazy } from 'react';

import { RouteObject } from 'react-router-dom';

const PricingPlan = lazy(() => import('@pages/landing/PricingPlan'));

export const PricingPlanRoutes: RouteObject[] = [
  {
    path: '/pricing-plan',
    element: (
      <React.Suspense>
        <PricingPlan />
      </React.Suspense>
    ),
  },
];
